module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('shell.developedBy')) + " "), _c('a', {
    attrs: {
      "href": "http://ivoice.tech",
      "target": "_blank"
    }
  }, [_vm._v("ivoice.tech")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cdd87ef"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/layout/FooterBar.vue
// module id = 313
// module chunks = 42